import { ReactElement, useMemo } from 'react';
import { Typography, Stack } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

import { useTypePartnerCompany } from '~hooks/useTypePartnerCompany';

import IntegrationsSection from '../IntegrationsSection';

import { DialogIntegrationsInfoProps } from './types';
import {
  DialogIntegrationsInfoContainer,
  DialogIntegrationsInfoHeader,
  DialogIntegrationsInfoHeaderCloseIcon,
  DialogIntegrationsInfoContent,
} from './styles';

const DialogIntegrationsInfo = ({
  open,
  onClose,
  list,
  loading,
  reload,
  hiddenTableEmpty = true,
}: DialogIntegrationsInfoProps): ReactElement => {
  const { isCarrier } = useTypePartnerCompany();

  const maxWidth = useMemo(() => (isCarrier ? 1200 : 1000), [isCarrier]);

  return (
    <DialogIntegrationsInfoContainer
      open={open}
      PaperProps={{ sx: { maxWidth } }}
    >
      <DialogIntegrationsInfoHeader>
        <Typography component="h2" variant="h6">
          Tiendas Conectadas
        </Typography>

        <DialogIntegrationsInfoHeaderCloseIcon
          aria-label="close"
          onClick={onClose}
          size="small"
        >
          <CloseIcon />
        </DialogIntegrationsInfoHeaderCloseIcon>
      </DialogIntegrationsInfoHeader>

      <DialogIntegrationsInfoContent dividers>
        <Typography variant="caption" color="text.secondary">
          Abre las puertas a la automatización al vincularte con otras tiendas y
          plataformas de comercio electrónico. Aprovecha la interacción fluida y
          eficiente para ahorrar tiempo y esfuerzo.
        </Typography>

        <Stack direction="row" flex={1}>
          <IntegrationsSection
            list={list}
            loading={loading}
            reload={reload}
            hiddenTableEmpty={hiddenTableEmpty}
          />
        </Stack>
      </DialogIntegrationsInfoContent>
    </DialogIntegrationsInfoContainer>
  );
};

export default DialogIntegrationsInfo;
